import { CdkDragDrop } from "@angular/cdk/drag-drop";
import { StatusPedido } from "../models/pedido";
import { KanbanPedido } from "./KanbamPedido";

export class KanbanGrupo {

    private _itens: KanbanPedido[] = [];
    private _listaDestacada = false;

    constructor(
        public nome: string,
        public ordem: number,
        public status: StatusPedido
    ) {
    }

    adicionarItem(item: KanbanPedido) {
        this._itens.push(item);
    }

    aceitaStatus(status: StatusPedido | number | string): boolean {
        return Number(status) === Number(this.status);
    }

    removerPedido(idPedido: number) {
        this._itens = this._itens.filter((item) => Number(item.pedido.id) !== idPedido);
    }

    ativarDestaqueDaLista() {
        this._listaDestacada = true;
    }

    desativarDestaqueDaLista() {
        this._listaDestacada = false;
    }

    get itens(): KanbanPedido[] {
        return this._itens;
    }

    get numeroDoStatus(): number {
        return Number(this.status);
    }

    get quantidadeDeItens(): number {
        return this._itens.length;
    }

    getPosicaoDoPedidoNoGrupo(idPedido: number | string): number {
        return this.itens.findIndex((elm) => Number(elm.pedido.id) === Number(idPedido));
    }

    getlistaDeIdDosPedidosNoGrupo(): string[] {
        return this.itens.map((item) => item.pedido.id);
    }

    getlistaDeHashDosPedidosNoGrupo(): string[] {
        return this.itens.map((item) => item.pedido.Hash);
    }

    get listaEstaDestacada(): boolean {
        return this._listaDestacada;
    }

    get numeroDoProximoStatus(): number {
        switch (this.status) {
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 6:
                return 2;
            default:
                return 1;
        }
    }

    get numeroDoStatusAnterior(): number {
        switch (this.status) {
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            default:
                return 1;
        }
    }


}


export class MovimentacaoManual {
    public item: KanbanPedido;
    public posicaoAtual: number;
    public posicaoAnterior: number;
    public grupoAtual: KanbanGrupo;
    public grupoAnterior: KanbanGrupo;

    constructor(evento: CdkDragDrop<KanbanGrupo>) {
        this.item = evento.item.data;
        this.posicaoAtual = evento.currentIndex;
        this.posicaoAnterior = evento.previousIndex;
        this.grupoAtual = evento.container.data;
        this.grupoAnterior = evento.previousContainer.data;
    }

    get movimentouNoMesmoGrupo(): boolean {
        return this.grupoAnterior === this.grupoAtual;
    }

    get movimentouParaOutroGrupo(): boolean {
        return this.grupoAnterior !== this.grupoAtual;
    }

}